<template>
    <div>
        <ResumeCard
            title="Language"
            icon="mdi-chat"
            color="teal"
            width="100%"
            min-height="550">
            <v-row class="pa-4 ma-0">
                <v-col
                    v-for="language in languages"
                    :key="language.name"
                    cols="4"
                    class="px-2">
                    <div>{{ language.name }}</div>
                    <SkillBar
                        v-for="skill in language.skills"
                        :key="skill.label"
                        v-bind="skill"
                        class="text-caption text-md-body-1" />
                </v-col>
            </v-row>
        </ResumeCard>
    </div>
</template>

<script>
import { languages } from '@/data/skills';
import ResumeCard from './ResumeCard.vue';
import SkillBar from './SkillBar.vue';

export default {
    name: 'LanguagesPanel',
    components: { ResumeCard, SkillBar },
    data: () => ({ languages }),
};
</script>
